import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'
import {
  hasAnyLeaveSettingsAccess,
  hasLeaveSettingAccess,
  type LeaveSettingAccessKey,
} from '@/services/leave/settingsAccess'

const moduleId = 6

export const canUserAccessModule = (user) => {
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && user.profile.modules.leave.isAccess
}

export const guardLeaveAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const guardRequest = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.leave?.requestAccess ? user.profile.modules.leave.requestAccess : { name: 'Home' }
}

export const guardLeaveAccounts = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.leave?.accountsAccess ? user.profile.modules.leave.accountsAccess : { name: 'Home' }
}

export const guardSelfRequest = (to) => {
  if (!to?.params?.resourceId)
    return { name: 'Home' }
  if (!to?.params?.leaveId)
    return { name: 'Home' }
  if (guardRequest() === true)
    return true
  const userStore = useUserStore()
  const user = userStore.user
  // Vérifie l'accès ou si c'est sa propre demande
  const hasAccess = user.profile.modules.leave?.selfRequestAccess
  console.log('to', to)
  const isOwnRequest = to?.params?.resourceId && String(to.params.resourceId) === String(user._id)
  return hasAccess || isOwnRequest ? true : { name: 'Home' }
}

export const guardNewRequest = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.leave?.newRequestAccess ? user.profile.modules.leave.newRequestAccess : { name: 'Home' }
}
export const guardNewBulkRequest = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.leave?.bulkCreateAccess ? user.profile.modules.leave.bulkCreateAccess : { name: 'Home' }
}

export const guardCalendar = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return user.profile.modules.leave?.calendarAccess ? user.profile.modules.leave.calendarAccess : { name: 'Home' }
}

export const guardLeaveSettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasAnyLeaveSettingsAccess(user.profile.modules.leave) || { name: 'Home' }
}

export const guardLeaveSettingAccess = (key: LeaveSettingAccessKey) => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasLeaveSettingAccess(user.profile.modules.leave, key) || { name: 'Home' }
}

export const guardLeaveInitialBalanceSettingsAccess = () => guardLeaveSettingAccess('settingsInitialBalanceAccess')
